"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMediaItemType = void 0;
var IMediaItemType;
(function (IMediaItemType) {
    IMediaItemType["Image"] = "Image";
    IMediaItemType["Video"] = "Video";
    IMediaItemType["AudioClip"] = "AudioClip";
    IMediaItemType["AudioPhrase"] = "AudioPhrase";
})(IMediaItemType || (exports.IMediaItemType = IMediaItemType = {}));
//# sourceMappingURL=media-item-type.js.map